var SENTRY_RELEASE;SENTRY_RELEASE={name: "Loman AI", version: "1.0.0"};